<template>
  <IconMaximize
    v-if="!fullscreen"
    class="button-fullscreen"
    role="button"
    tabindex="0"
    @click="emits('toggleFullscreen')"
    @keydown.enter="emits('toggleFullscreen')"
    @keydown.space="(event: Event) => handleSpaceKey(event)"
  />
  <IconMinimize
    v-else
    class="button-fullscreen"
    role="button"
    tabindex="0"
    :class="{ medium: size === 'medium' }"
    @click="emits('toggleFullscreen')"
    @keydown.enter="emits('toggleFullscreen')"
    @keydown.space="(event: Event) => handleSpaceKey(event)"
  />
</template>

<script lang="ts" setup>
import IconMaximize from '@/design-system/assets/icons/IconMaximize2.vue'
import IconMinimize from '@/design-system/assets/icons/IconMinimize2.vue'
type Props = {
  fullscreen?: boolean
  size?: string
}

type Emits = {
  (e: 'toggleFullscreen'): void
}

defineProps<Props>()
const emits = defineEmits<Emits>()

function handleSpaceKey(event: Event) {
  event.preventDefault() // Prevent space bar scrolling
  emits('toggleFullscreen')
}
</script>

<style lang="scss" scoped>
.button-fullscreen {
  width: 16px;
  height: 16px;
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: auto;
  }
  &:hover {
    cursor: pointer;
  }
}
.button-fullscreen.medium {
  width: 24px;
  height: 24px;
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: auto;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
